import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsDrawerSystemsValue = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.drawerSystems.value;

export const value = setCalculationModeAdminSettingsDrawerSystemsValue(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_DRAWER_SYSTEMS_VALUE',
  { value: '', label: '' }
);
